import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import styled from "styled-components";
import { BlogPostsCarousel } from "./BlogPostsCarousel";
import Reveal from "../v2/Reveal";
import { SectionV2, HeadV2, PillButton, accents } from "../v2/primitives";

const Blog = ({ posts }) => {
	const { t } = useTranslation();
	const router = useRouter();
	const title = t("blogSection.title");
	const titleWords = title.split(" ");
	const lastWord = titleWords.pop();
	const hasPosts = Array.isArray(posts) && posts.length > 0;

	return (
		<BlogSection id="media" $accent={accents.lime} $glowAt="85% 0%">
			<div className="head-pad">
				<Reveal>
					<HeadV2 $accent={accents.lime}>
						<span className="overline">Blog</span>
						<h2>
							{titleWords.join(" ")} <em>{lastWord}</em>
						</h2>
						<p>{t("blogSection.description")}</p>
					</HeadV2>
				</Reveal>
			</div>
			{hasPosts ? (
				<Reveal y={34}>
					<BlogPostsCarousel posts={posts} />
				</Reveal>
			) : (
				/* CMS unavailable or no posts: keep the section alive with a
				   direct route to the blog instead of an empty carousel */
				<div className="head-pad">
					<Reveal>
						<EmptyState>
							<PillButton
								$accent={accents.lime}
								onClick={() =>
									router.push(`/${router.query.locale || "pt"}/blog`)
								}
							>
								{t("blogSection.readMore")}
								<svg
									width="15"
									height="15"
									viewBox="0 0 16 16"
									fill="none"
									aria-hidden="true"
								>
									<path
										d="M3 8h10M9 4l4 4-4 4"
										stroke="currentColor"
										strokeWidth="1.6"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</PillButton>
						</EmptyState>
					</Reveal>
				</div>
			)}
		</BlogSection>
	);
};

const EmptyState = styled.div`
  display: flex;
  justify-content: center;
`;

/* the carousel manages its own horizontal margins, so the section is flush */
const BlogSection = styled(SectionV2)`
  padding-left: 0;
  padding-right: 0;

  @media (min-width: 992px) {
    padding-left: 0;
    padding-right: 0;
  }

  .head-pad {
    position: relative;
    z-index: 1;
    padding: 0 24px;

    /* align the head with the carousel margins, capped at the same
       1216px grid the other v2 sections use (InnerV2) */
    @media (min-width: 992px) {
      padding: 0;
      margin: 0 max(5.55vw, calc((100% - 1216px) / 2));
    }
  }
`;

export default Blog;
